interface GetHeaderTitleProps {
  isReadOnly: boolean;
  title: string;
  id?: string | number;
}

export const getHeaderTitle = ({
  isReadOnly,
  title,
  id,
}: GetHeaderTitleProps) => {
  if (isReadOnly) {
    return `View ${title}`;
  }
  if (!id) {
    return `New ${title}`;
  }

  return `Edit ${title}`;
};
